(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-api-legacy"] && !Shopify.designMode) return;
  try {
    const allowedKeys = [
    'go_memory_preset_quiz',
    'go_glp1_preset_quiz',
    'go_female_preset_quiz',
    'go_muscle_preset_quiz',
    'bioniq-questionnaire-shopify',
  ];
  document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    const uuid = urlParams.get('formula_draft_uuid');

    function findQuestionByKey(apiResponse, keyToFind) {
      const currentKey = apiResponse?.input_params?.bioniq_go_questionnaire_key;

      if (!allowedKeys.includes(currentKey)) {
        return null;
      }

      const questionnaire = apiResponse?.input_params?.bioniq_go_questionnaire;

      if (!questionnaire) {
        console.error('Questionnaire data not found in the response.');
        return undefined;
      }

      const foundQuestion = questionnaire.find((question) => question.question_key === keyToFind);

      return foundQuestion;
    }

    function saveUrlParamsAsCookies() {
      const urlParams = new URLSearchParams(window.location.search);
      const uuid = urlParams.get('formula_draft_uuid');

      if (uuid) {
        document.cookie = `formula_draft_uuid=${uuid}; path=/`;
      }
    }

    // Function to generate a slide HTML string
    function createSwiperSlide(imageData, type = 'main') {
      const imageUrl = imageData.img; // Assuming image object has a 'src' property from metafield
      const subtitle = imageData.subtitle || ''; // Define the subtitle variable

      const altText = imageData.alt || subtitle;
      const dataId = imageData.id || `dynamic-${Math.random().toString(36).substring(7)}`; // Generate a unique ID if metafield image doesn't have one
      const mainSwiperEl = document.querySelector('.main-swiper');
      const thumbnailSwiperEl = document.querySelector('.thumbnail-swiper');
      const mainSwiperInstance = mainSwiperEl ? mainSwiperEl.swiper : null;
      const thumbnailSwiperInstance = thumbnailSwiperEl ? thumbnailSwiperEl.swiper : null;

      let finalImageUrl = imageUrl;
      // Add a class to identify dynamically added slides for removal later
      const dynamicClass = type === 'main' ? 'dynamic-gender-slide' : 'dynamic-gender-thumbnail';
      // Append/replace width parameters for Shopify CDN if desired
      const slideElement = document.createElement('div');

      if (type === 'main') {
        slideElement.className = `swiper-slide ${dynamicClass}`;
        slideElement.innerHTML = `
        <div class="slide-border">
          <img src="${imageUrl}" alt="${altText}" class="main-image">
        </div>
      `;
      } else {
        // type === 'thumbnail'
        if (finalImageUrl.includes('?')) {
          finalImageUrl += '&width=60';
        } else {
          finalImageUrl += '?width=60';
        }
        slideElement.className = `swiper-slide thumb-slide ${dynamicClass}`;
        slideElement.innerHTML = `
        <img src="${finalImageUrl}" alt="${altText}" class="thumbnail">
        <span class="thumbnail-subtitle">${subtitle}</span>
      `;
      }
      return slideElement;
    }

    // staging

    const CONFIG = {
      STAGING: {
        QUIZ: 'https://my-staging.bioniq.com',
        CLIENT_APP_PUBLIC: 'e73ddc0b-368c-45f5-aff8-ae61ab7d9a1a',
        API_ROOT: 'https://api-stg.bioniq.com/',
      },
      PROD: {
        QUIZ: 'https://go-checkout.bioniq.com',
        CLIENT_APP_PUBLIC: 'ea809916-f5b6-42cf-b762-869c07d945bf',
        API_ROOT: 'https://api-prod.bioniq.com/',
      },
    };

    function determineEnv() {
      let env = 'PROD';
      if (
        window.location.href.includes('global-dev') ||
        window.location.href.includes('nekko') ||
        window.location.href.includes('127.0.0.1')
      ) {
        env = 'STAGING';
      }
      return env;
    }

    // Call the function when the page loads
    saveUrlParamsAsCookies();

    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }

    // Check for UUID in URL parameter or cookie
    const uuidFromUrl = urlParams.get('formula_draft_uuidd');
    const uuidFromCookie = getCookie('formula_draft_uuid');
    const hasUuid = uuidFromUrl || uuidFromCookie; // Check if either exists

    function isAdminEditor() {
      try {
        // Try accessing the parent window's location
        const parentLocation = window.parent.location.href;

        // Check if the parent URL contains 'admin.shopify.com/store/' and '/editor?'
        return parentLocation.includes('admin.shopify.com/store/') && parentLocation.includes('/editor?');
      } catch (e) {
        // If there's an error (e.g., cross-origin), it's not the theme editor iframe
        return true;
      }
    }

    if (!isAdminEditor()) {
      if (!hasUuid) {
        console.error('UUID parameter is missing. set redirect in bioniq/snippets/product-variant-options.liquid');
        return; // Stop further execution
      }
    }

    const currentEnv = determineEnv();
    const API_ROOT = CONFIG[currentEnv].API_ROOT;
    const CLIENT_APP = CONFIG[currentEnv].CLIENT_APP_PUBLIC;
    // staging
    const apiUrl = `${API_ROOT}/public/api/v1/go/formula_drafts?uuid=${hasUuid}`;
    const clientAppHeader = CLIENT_APP;

    const preloader = document.getElementById('preloader-element');
    // preloader.id = 'preloader-element'; // Give it an ID for styling
    // preloader.textContent = 'Loading...'; // Or use an image/spinner
    // document.body.appendChild(preloader); // Add to the page

    // case "SKIN":
    //   return "#ffe1c7";
    // case "LIBIDO":
    //   return "#fad3e6";
    // case "MEMORY":
    //   return "#fad3e6";
    // case "LIVER":
    //   return "#fef8e0";
    // case "MUSCLE":
    //   return "#fef8e0";
    // case "SLEEP":
    //   return "#e7f4fc";
    // case "OPERATIVE":
    //   return "#e5f6e6";
    // case "IMMUNE":
    //   return "#e5f6e6";
    // case "AGING":
    //   return "#e5f6e6";
    // case "HEART":
    //   return "#fad0d1";
    // case "IRON":
    //   return "#fad0d1";
    // case "BONES":
    //   return "#F0F0F0";

    const healthGoalsDefinition = {
      skin: {
        text: 'Skin, hair and nails',
        icon: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/hair.svg',
        iconActive: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/hair-active.svg',
        background: '#ffe1c7',
        graphimg: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/graphs/hair.svg',
      },
      libido: {
        text: 'Libido',
        icon: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/libido.svg',
        iconActive: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/libido-active.svg',
        background: '#fad3e6',
        graphimg: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/graphs/libido.svg',
      },
      memory: {
        text: 'Memory and focus',
        icon: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/memory.svg',
        iconActive: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/memory-active.svg',
        background: '#fad3e6',
        graphimg: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/graphs/memory.svg',
      },
      liver: {
        text: 'Liver function',
        icon: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/liver.svg',
        iconActive: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/liver-active.svg',
        background: '#fef8e0',
        graphimg: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/graphs/liver.svg',
      },
      sleep: {
        text: 'Sleep and anxiety',
        icon: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/sleep.svg',
        iconActive: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/sleep-active.svg',
        background: '#e7f4fc',
        graphimg: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/graphs/sleep.svg',
      },
      aging: {
        text: 'Healthy aging',
        icon: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/aging.svg',
        iconActive: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/aging-active.svg',
        background: '#e5f6e6',
        graphimg: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/graphs/aging.svg',
      },
      'immune-support': {
        text: 'Immune support',
        icon: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/immune-support.svg',
        iconActive: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/immune-support-active.svg',
        background: '#e5f6e6',
        graphimg: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/graphs/immune-support.svg',
      },
      heart: {
        text: 'Heart and blood vessels',
        icon: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/heart.svg',
        iconActive: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/heart-active.svg',
        background: '#fad0d1',
        graphimg: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/graphs/heart.svg',
      },
      muscle: {
        text: 'Muscle strength',
        icon: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/muscle.svg',
        iconActive: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/muscle-active.svg',
        background: '#fef8e0',
        graphimg: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/graphs/muscle.svg',
      },
      bones: {
        text: 'Bones and joints',
        icon: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/bones.svg',
        iconActive: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/bones-active.svg',
        background: '#F0F0F0',
        graphimg: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/graphs/bones.svg',
      },
      iron: {
        text: 'Iron levels',
        icon: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/iron.svg',
        iconActive: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/iron-active.svg',
        background: '#fad0d1',
        graphimg: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/graphs/iron.svg',
      },
      operative: {
        text: 'Pre/Post-operative period',
        icon: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/operative.svg',
        iconActive: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/byo/goals/operative-active.svg',
        background: '#e5f6e6',
        graphimg: 'https://bioniq-global-cdn.s3.eu-central-1.amazonaws.com/img/graphs/operation.svg',
      },
    };

    const healthGoalsMap = {
      iron_levels: 'iron',
      'iron-levels-yes': 'iron',
      'libido-yes': 'libido',
      libido: 'libido',
      'skin-hair-nails-yes': 'skin',
      skin_hair_and_nails: 'skin',
      liver_function: 'liver',
      'liver-function-yes': 'liver',
      sleep_and_anxiety: 'sleep',
      'sleep-and-anxiety-yes': 'sleep',
      healthy_aging: 'aging',
      'healthy-aging-yes': 'aging',
      heart_and_blood_vessels: 'heart',
      'heart-and-blood-vessels-yes': 'heart',
      muscle_strength: 'muscle',
      'muscle-strength-yes': 'muscle',
      'immune-support-yes': 'immune-support',
      immune_support: 'immune-support',
      'bones-and-joints-yes': 'bones',
      bones_and_joints: 'bones',
      'memory-and-focus-yes': 'memory',
      'memory-and-focus': 'memory',
      memory_and_focus: 'memory',
      'operative-yes': 'operative',
      'pre_post-operative_period': 'operative',
    };

    const ingredientImageMap = {
      Ginseng: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-ginseng.png?v=1752485545',
      Arginine: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-arginine.png?v=1752485545',
      'Vitamin B6': 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-vitamin-b6.png?v=1752485545',
      'Vitamin B7': 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-vitamin-b7.png?v=1752485545',
      Isoflavone: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-isoflavone.png?v=1752485545',
      Ashwagandha: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-ashwagandha.png?v=1752485545',
      '5HTP': 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-5htp.png?v=1752485545',
      'Coenzyme Q10': 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-coenzyme-q10.png?v=1752485545',
      'Vitamin E': 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-vitamin-e.png?v=1752485545',
      'Vitamin C': 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-vitamin-c.png?v=1752485545',
      'Glucosamine Sulphate':
        'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-glucosamine-sulphate.png?v=1752485545',
      'Broccoli Extract':
        'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-broccoli-extract.png?v=1752485545',
      Iodine: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-iodine.png?v=1752485545',
      Ginkgo: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-ginkgo.png?v=1752485545',
      Copper: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-copper.png?v=1752485545',
      Cocoa: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-cocoa.png?v=1752485545',
      'Artichoke Extract':
        'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-artichoke-extract.png?v=1752485545',
      Chromium: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-chromium.png?v=1752485545',
      'Vitamin B9': 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-vitamin-b9.png?v=1752485545',
      Quercetin: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-quercetin.png?v=1752485545',
      Collagen: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-collagen.png?v=1752485545',
      Silymarin: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-silymarin.png?v=1752485545',
      Carnosin: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-carnosin.png?v=1752485545',
      Pomegranate: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-pomegranate.png?v=1752485545',
      Tryptophan: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-tryptophan.png?v=1752485545',
      Resveratrol: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-resveratrol.png?v=1752485545',
      'Pine Bark': 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-pine-bark.png?v=1752485545',
      'Vitamin K2': 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-vitamin-k2.png?v=1752485545',
      Niacin: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-niacin.png?v=1752485545',
      Curcumin: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-curcumin.png?v=1752485545',
      'Lipoic Acid': 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-lipoic-acid.png?v=1752485545',
      Proline: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-proline.png?v=1752485545',
      Isoleucine: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-isoleucine.png?v=1752485545',
      'Vitamin B12': 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-vitamin-b12.png?v=1752485545',
      Potassium: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-potassium.png?v=1752485545',
      Calcium: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-calcium.png?v=1752485545',
      Glutamine: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-glutamine.png?v=1752485545',
      Magnesium: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-magnesium.png?v=1752485545',
      Glycine: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-glycine.png?v=1752485545',
      Same: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-same.png?v=1752485545',
      Carnitine: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-carnitine.png?v=1752485545',
      Placeholder: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/placeholder.png?v=1752485545',
      Selenium: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-selenium.png?v=1752485545',
      Lysine: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-lysine.png?v=1752485545',
      Glutathione: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-glutathione.png?v=1752485545',
      Bor: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-bor.png?v=1752485545',
      Creatine: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-creatine.png?v=1752485545',
      Rhodiola: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-rhodiola.png?v=1752485545',
      'Vitamin B1': 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-vitamin-b1.png?v=1752485545',
      Moringa: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-moringa.png?v=1752485545',
      Ornithine: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-ornithine.png?v=1752485545',
      'Vitamin D3': 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-vitamin-d3.png?v=1752485545',
      Tyrosine: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-tyrosine.png?v=1752485545',
      Phenylalanin: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-phenylalanin.png?v=1752485544',
      Leucine: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-leucine.png?v=1752485545',
      Taurine: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-taurine.png?v=1752485544',
      Chaga: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-chaga.png?v=1752485544',
      Zinc: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-zinc.png?v=1752485545',
      Iron: 'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/ingr-iron.png?v=1752485544',
    };

    function getAnswerKeys(data, allowedKeys, questionnaireObjectKey) {
      const draftKey = data?.input_params?.bioniq_go_questionnaire_key;
      if (allowedKeys.includes(draftKey)) {
        const questionnaire = data?.input_params?.[questionnaireObjectKey];
        if (Array.isArray(questionnaire)) {
          const TARGET_QUESTION_KEYS = [
            'what_is_your_current_fitness_goal',
            'which_areas_of_your_health_are_you_interested_in_focusing_on',
          ];

          const foundQuestion = questionnaire.find((q) => {
            return TARGET_QUESTION_KEYS.includes(q.question_key);
          });

          return foundQuestion?.answer_keys || null;
        }
      } else {
        if (data?.input_params?.answer_keys) {
          return data.input_params.answer_keys;
        }
      }

      return null;
    }

    function pollForFunction(functionName, timeout = 2000, interval = 100) {
      const startTime = Date.now();

      // The inner check function is now async to handle awaiting the target
      const check = async () => {
        // Check if the function now exists
        if (typeof window[functionName] === 'function') {
          try {
            // Await the function call to handle promises
            await window[functionName]();
          } catch (error) {
            console.error(`Error executing ${functionName}:`, error);
          }
        }
        // Check if we've timed out
        else if (Date.now() - startTime > timeout) {
          console.error(`${functionName} was not found within ${timeout}ms.`);
        }
        // If not found and not timed out, try again
        else {
          setTimeout(check, interval);
        }
      };

      check(); // Start the first check
    }

    function extractHealthGoals(answerKeys) {
      if (!Array.isArray(answerKeys)) return [];

      return answerKeys.filter((key) => healthGoalsMap.hasOwnProperty(key)).map((key) => healthGoalsMap[key]);
    }

    let health_goals_array = [];

    fetch(apiUrl, {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'Client-App': clientAppHeader,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(async (data) => {
        preloader?.remove();
        document.body.classList.remove('preloader-active');

        const fullNameObject = findQuestionByKey(data, 'what_s_your_full_name');

        // 1. Standardize the name retrieval into a single variable.
        //    Use the logical OR (||) operator to get the first available value.
        const userName = data?.full_name || fullNameObject?.free_answer_value || '';
        const emailObject = findQuestionByKey(data, 'what_s_your_e-mail_address');
        const email = data?.email || emailObject?.free_answer_value;
        console.log(data);
        window.emailObject = email;
        console.log(window.emailObject);

        // 2. Perform a single, clean check to see if a name was found.
        if (userName) {
          const personalizedMessage = `<span style="text-transform: capitalize;">${userName}</span>, your personalized formula is ready`;

          // 3. Update all relevant DOM elements efficiently.
          const namePlaceholders = document.querySelectorAll('#namePlaceholder, #namePlaceholderPopup');
          const titlePlaceholders = document.querySelectorAll('#titlePlaceholder, #banner-message');

          // Update elements that just show the name
          namePlaceholders.forEach((element) => {
            if (element) element.textContent = userName;
          });

          // Update elements that show the full message
          titlePlaceholders.forEach((element) => {
            if (element) element.innerHTML = personalizedMessage;
          });
        } else {
          console.log('User name not found in the data.');
        }

        // Call the function with the specific questionnaire key
        const answerKeys = getAnswerKeys(data, allowedKeys, 'bioniq_go_questionnaire');

        if (answerKeys) {
          health_goals_array = extractHealthGoals(answerKeys);
        }

        if (health_goals_array.length > 0) {
          const graphSlider = document.getElementById('graphs-slider');
          const healthAdvicesPlaceholder = document.getElementById('productHealthGoalsPlaceholder');

          if (graphSlider) {
            health_goals_array.forEach((goal) => {
              const goalData = healthGoalsDefinition[goal];
              const { text, icon, background, graphimg } = goalData;

              const graphSlide = document.createElement('div');
              graphSlide.classList.add('swiper-slide', 'mod--graphs');

              // Create the inner structure of the slide
              graphSlide.innerHTML = `
              <div class="graph-slide" style="background:${background}">
                <div class="graph-slide--head">
                  ${icon ? `<img loading="lazy" src="${icon}" alt="${text}" class="graph-slide--ico">` : ''}
                  <div>${text}</div>
                </div>
                ${
                  graphimg
                    ? `<img width="Auto" loading="lazy" alt="${text}" src="${graphimg}" class="graph-slide--img">`
                    : ''
                }
              </div>
            `;

              graphSlider.appendChild(graphSlide);

              const adviceItem = document.createElement('div');
              const adviceItemIcon = document.createElement('div');
              adviceItem.classList.add('health-advice');
              adviceItemIcon.classList.add('icon');
              adviceItemIcon.classList.add(goal);
              adviceItem.textContent = text; // Or advice.title, etc.
              adviceItem.appendChild(adviceItemIcon);
              healthAdvicesPlaceholder.appendChild(adviceItem);
            });

            if (health_goals_array.length === 3) {
              graphSlider.classList.add('three-goals');
            }

            if (health_goals_array.length === 1) {
              graphSlider.classList.add('one-goal');
            }
          }
        }
        if (!health_goals_array || health_goals_array == null || health_goals_array.length == 0) {
          const healthAdvicesPlaceholder = document.querySelector('h3.product-subtitle');

          healthAdvicesPlaceholder.innerText = '2 scoops daily';
        }

        if (data && data.draft && data.draft.ingredients) {
          const ingredientsPlaceholder = document.getElementById('ingredientsListPlaceholder');
          const ingredientsCountPlaceholder = document.getElementById('ingredientsCountPlaceholder');
          const ingredientsList = data.draft.ingredients;

          ingredientsList.forEach((object, index) => {
            // Use your current naming and mappings
            const ingredient = object.ingredient;
            const imageSrc =
              ingredientImageMap[ingredient.name] ||
              'https://cdn.shopify.com/s/files/1/0748/0924/5918/files/placeholder.png?v=1752485545';

            // Health goals icons
            let healthGoalsHtml = '';
            if (ingredient.health_goals && ingredient.health_goals.length) {
              healthGoalsHtml = ingredient.health_goals
                .map((goalKey) => {
                  const mappedKey = Object.entries(healthGoalsMap).find(([_, value]) => value === goalKey)?.[0];
                  const definition = healthGoalsDefinition[goalKey];
                  const ingredientClass = goalKey.toLowerCase().replace(/\s+/g, '-');

                  return definition
                    ? `<div class="bq-ingredeient-Faq-healthgoal-icon ${ingredientClass}" title="${definition.text}">
                <img class="healthgoal-icon" src="${definition.icon}" alt="${definition.text}" />
                <div class="healthgoal-text">${definition.text}</div>
              </div>`
                    : '';
                })
                .join('');
            }

            // Why we added section
            let whyWeAddedHtml = '';
            if (ingredient.why_we_added) {
              whyWeAddedHtml = `
        <div class="bq-ingredeient-Faq-details-why-we-added">
          <div class="bq-ingredeient-Faq-details-why-we-added-heading">
            Why we added this component
          </div>
          <div class="bq-ingredeient-Faq-details-why-we-added-details">
            ${ingredient.why_we_added}
          </div>
        </div>
      `;
            }

            const nrvHtml =
              object.nrv_percent != null && object.nrv_percent !== ''
                ? `<div class="bq-ingredeient-Faq-right-NRV">${object.nrv_percent}</div>`
                : '';

            const descriptionHtml = ingredient.description
              ? `<div class="bq-ingredeient-Faq-details-description">
            ${ingredient.description}
          </div>`
              : '';
            // Main FAQ HTML
            const faqHtml = `
      <div class="bq-ingredeient-Faq active">
        <div class="bq-ingredeient-Faq-header">
          <div class="bq-ingredeient-Faq-left">
            <div class="bq-ingredeient-Faq-img">
              <img src="${imageSrc}" alt="${ingredient.name}">
            </div>
            <div class="bq-ingredeient-Faq-name-container">
              <div class="bq-ingredeient-Faq-name">${index + 1}. ${ingredient.name}</div>
              ${ingredient.tagline ? `<div class="bq-ingredeient-Faq-sub-heading">${ingredient.tagline}</div>` : ''}
            </div>
          </div>
          <div class="bq-ingredeient-Faq-right">
            <div class="bq-ingredeient-Faq-right-quantity">${object.amount_per_serving}${object.unit}</div>
            ${nrvHtml}
            <div class="bq-ingredeient-Faq-right-icon">
              <!-- SVGs for open/close icons -->
              <svg class="bq-ingredeient-Faq-right-icon-close" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <rect x="0.5" y="1" width="23" height="23" rx="11.5" stroke="#1098D4"/>
                <path d="M7 11L12 16L17 11" stroke="#1098D4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg class="bq-ingredeient-Faq-right-icon-open" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.15057 15.3501C6.48154 15.6811 7.01815 15.6811 7.34912 15.3501L11.9998 10.6994L16.6506 15.3501C16.9815 15.6811 17.5181 15.6811 17.8491 15.3501C18.1801 15.0191 18.1801 14.4825 17.8491 14.1515L12.5991 8.90155C12.4402 8.74261 12.2246 8.65332 11.9998 8.65332C11.7751 8.65332 11.5595 8.74261 11.4006 8.90155L6.15057 14.1515C5.8196 14.4825 5.8196 15.0191 6.15057 15.3501Z" fill="#1098D4"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="bq-ingredeient-Faq-content-wrapper">
          <div class="bq-ingredeient-Faq-content">
            <div class="bq-ingredeient-Faq-conten-details">
              <div class="bq-ingredeient-Faq-conten-details-dosage">
                Recommended dosage: ${object.amount_per_serving}${object.unit} per day 
              </div>
              <!--
              <div class="bq-ingredeient-Faq-conten-details-total">
                Total: ${object.total || '150mg (milligram)'}
              </div>
              -->
              <div class="bq-ingredeient-Faq-conten-details_component_sources">
                Form: ${ingredient.component_sources}
              </div>
              <div class="bq-ingredeient-Faq-conten-details-Methylated">
                Methylated: ${ingredient.methylated ? 'Yes' : 'No'}
              </div>
            </div>
          </div>
          ${descriptionHtml}
          <div class="bq-ingredeient-Faq-details-icons">
            <div><img src="https://my.bioniq.com/cdn/shop/files/Frame_2087325372.png?v=1741879065"></div>
            <div><img src="https://my.bioniq.com/cdn/shop/files/Frame_2087325371.png"></div>
            <div><img src="https://my.bioniq.com/cdn/shop/files/Frame_2087325373.png"></div>
            <div><img src="https://my.bioniq.com/cdn/shop/files/Frame_2087325369_1.png"></div>
            <div><img src="https://my.bioniq.com/cdn/shop/files/Frame_2087325368_1.png"></div>
          </div>
          <div class="bq-ingredeient-Faq-details-healthgoals">
            ${healthGoalsHtml}
          </div>
          ${whyWeAddedHtml}
        </div>
      </div>
    `;

            // Append to container
            ingredientsPlaceholder.insertAdjacentHTML('beforeend', faqHtml);
          });

          ingredientsCountPlaceholder.textContent = `(${ingredientsList.length})`;

          document.querySelectorAll('.product__healthgoals .health-advice').forEach((adviceEl) => {
            const text = adviceEl.innerText.trim();
            // Match from your healthGoalsDefinition object
            const match = Object.values(healthGoalsDefinition).find(
              (obj) => obj.text.toLowerCase() === text.toLowerCase()
            );
            if (!match) return;

            // Build filter row HTML and append to popup
            const filterPopup = document.querySelector('.filter-popup');
            if (filterPopup) {
              const html = `
      <div class="filter-row" data-goal="${match.text.toLowerCase()}">
        <div class="icon-tip"><img src="${match.icon}" alt="icon" /></div>
        <div class="active-icon-tip"><img src="${match.iconActive}" alt="active icon" /></div>
        <div class="text">${match.text}</div>
        <div class="close">
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.18394 4.18882C4.4344 3.93836 4.84048 3.93836 5.09095 4.18882L7.99609 7.09397L10.9012 4.18882C11.1517 3.93836 11.5578 3.93836 11.8082 4.18882C12.0587 4.43929 12.0587 4.84537 11.8082 5.09583L8.9031 8.00098L11.8082 10.9061C12.0587 11.1566 12.0587 11.5627 11.8082 11.8131C11.5578 12.0636 11.1517 12.0636 10.9012 11.8131L7.99609 8.90798L5.09095 11.8131C4.84048 12.0636 4.4344 12.0636 4.18394 11.8131C3.93348 11.5627 3.93348 11.1566 4.18394 10.9061L7.08909 8.00098L4.18394 5.09583C3.93348 4.84537 3.93348 4.43929 4.18394 4.18882Z" fill="#1098D4"/>
          </svg>
        </div>
      </div>
    `;
              filterPopup.insertAdjacentHTML('beforeend', html);
            }
          });
        } else {
          console.log('Ingredients data not found.');
        }

        function updateProductGallery(variantId, gender) {
          // gender is 1 for male, 2 for female
          let allVariantGalleries = {};
          try {
            allVariantGalleries = JSON.parse(document.getElementById('variantGalleriesData').textContent);
          } catch (e) {
            console.log(e);
          }

          const mainSwiperInstance = document.querySelector('.main-swiper')?.swiper;
          const thumbnailSwiperInstance = document.querySelector('.thumbnail-swiper')?.swiper;

          if (!mainSwiperInstance || !thumbnailSwiperInstance || !allVariantGalleries[variantId]) {
            console.error('Cannot update gallery: Swiper or variant data missing.');
            return;
          }

          // --- IMPROVED SLIDE REMOVAL LOGIC ---
          // 1. Find and remove all previously added dynamic slides
          const mainSlidesToRemove = [];
          mainSwiperInstance.slides.forEach((slide, index) => {
            if (slide.classList.contains('dynamic-gender-slide')) {
              mainSlidesToRemove.push(index);
            }
          });
          if (mainSlidesToRemove.length > 0) mainSwiperInstance.removeSlide(mainSlidesToRemove);

          const thumbSlidesToRemove = [];
          thumbnailSwiperInstance.slides.forEach((slide, index) => {
            if (slide.classList.contains('dynamic-gender-thumbnail')) {
              thumbSlidesToRemove.push(index);
            }
          });
          if (thumbSlidesToRemove.length > 0) thumbnailSwiperInstance.removeSlide(thumbSlidesToRemove);

          // 2. Determine which images to display
          const genderKey = gender === 1 ? 'male' : 'female';
          const imagesToDisplay = allVariantGalleries[variantId][genderKey]?.images || [];

          // 3. Add new slides one-by-one, starting after the static slides
          mainSwiperInstance.removeAllSlides();
          thumbnailSwiperInstance.removeAllSlides();

          const staticSlideCount = 0; // Assuming 0 static slides

          imagesToDisplay.forEach((imageData, i) => {
            const mainSlideElement = createSwiperSlide(imageData, 'main');
            const thumbSlideElement = createSwiperSlide(imageData, 'thumbnail');

            if (mainSlideElement) {
              mainSwiperInstance.addSlide(staticSlideCount + i, mainSlideElement);
            }
            if (thumbSlideElement) {
              thumbnailSwiperInstance.addSlide(staticSlideCount + i, thumbSlideElement);
            }
          });

          // 4. Update Swiper instances
          mainSwiperInstance.update();
          thumbnailSwiperInstance.update();
          mainSwiperInstance.slideTo(0); // Go to the first slide

          const wrapper = document.getElementById('thumbnail-wrapper');
          if (wrapper) {
            const imageCount = wrapper.querySelectorAll('.thumb-slide').length;
            wrapper.classList.toggle('less-than-five', imageCount < 5);
          }
        }

        // Handle gender-based image display

        // i provided fallback for different data structure
        let gender = null;
        let gender_string = findQuestionByKey(data, 'which_sex_were_you_assigned_at_birth');
        if (gender_string) {
          if (gender_string === 'male') {
            gender = 1;
          } else {
            gender = 2;
          }
        }
        if (
          (data && data.input_params && data.input_params.profile && data.input_params.profile.gender) ||
          gender != null
        ) {
          if (gender == null) {
            gender = data?.input_params?.profile?.gender;
          }

          const updateImagesByGender = (container, selector) => {
            const elements = container.querySelectorAll(selector);

            elements.forEach((element) => {
              const femaleImage = element.querySelector('.female-image');
              const maleImage = element.querySelector('.male-image');

              if (gender === 1) {
                // Male
                if (femaleImage) femaleImage.style.display = 'none';
                if (maleImage) maleImage.style.display = 'block';
              } else if (gender === 2) {
                // Female
                if (femaleImage) femaleImage.style.display = 'block';
                if (maleImage) maleImage.style.display = 'none';
              }
            });
          };

          // Apply the function to your sections
          updateImagesByGender(document, '.how--tip-item');
          updateImagesByGender(document, '._3m-card'); // Note: The class was '3m-card' in your example, corrected to '_3m-card' if that's what you intended based on the div class. Please double check.

          // --- NEW: Gallery Dynamic Content Generation using Swiper's API ---
          // --- Call the new gallery function on initial load ---
          const initialVariantRadio = document.querySelector('.product-form__input input[type="radio"]:checked');
          if (initialVariantRadio) {
            const initialVariantId = initialVariantRadio.dataset.variantId;
            updateProductGallery(initialVariantId, gender);
          }

          // --- Add event listener for variant changes ---
          const variantRadios = document.querySelectorAll('.product-form__input input[type="radio"]');
          variantRadios.forEach((radio) => {
            radio.addEventListener('change', (event) => {
              const selectedVariantId = event.target.dataset.variantId;
              updateProductGallery(selectedVariantId, gender);
            });
          });
        }

        if (data && Object.keys(data).length > 0) {
          // Check if data object is not empty
          // Data is a single object, not an array
          const dataContainer = document.createElement('div');

          // Access properties of the data object and display them
          for (const key in data) {
            // Loop through the object's properties
            if (data.hasOwnProperty(key)) {
              // Check if it's the object's own property
              const itemElement = document.createElement('p');
              itemElement.textContent = `${key}: ${JSON.stringify(data[key])}`; // Show property: value
              dataContainer.appendChild(itemElement);
            }
          }
          //document.body.appendChild(dataContainer);
        } else {
          console.log('No data or unexpected format received.');
          const messageElement = document.createElement('p');
          messageElement.textContent = 'No data available.';
          //document.body.appendChild(messageElement);
        }
      })
      .catch((error) => {
        console.log(error);
        console.error('Error fetching data:', error);
        // Hide preloader
        setTimeout(() => {
          preloader?.remove();
          document.body.classList.remove('preloader-active');
        }, 1000);

        // Check for 404 in the error message
        if (error.message.includes('status: 404')) {
          if (!isAdminEditor()) {
            window.location.href = CONFIG[currentEnv].QUIZ;
          }
          return; // Stop further execution
        }
      });
  });
  } catch(e) { console.error(e); }
})();

})();
